const files: Partial<{
  gid: string;
  uid: string;
  fileList: any[];
}>[] = [];

export function addFile(file: any, gid: string) {
  const fileObject = files.find((x) => x.gid === gid);
  if (fileObject) {
    fileObject.fileList!.push(file);
  } else {
    const fileObjectIndex = files.push({ gid, fileList: [] }) - 1;
    files[fileObjectIndex].fileList!.push(file);
  }
}

export function removeFile(uid: string, gid: string) {
  const fileObject = files.find((x) => x.gid === gid);
  if (fileObject) {
    const index = fileObject.fileList!.findIndex((x) => x.uid === uid);
    if (index !== -1) {
      fileObject.fileList!.splice(index, 1);
    }
  }
}

export function getFilebyUid(uid: string, gid: string) {
  const fileObject = files.find((x) => x.gid === gid);
  if (fileObject) {
    return fileObject.fileList!.find((x) => x.uid === uid);
  }

  return null;
}

/**
 *
 * @param img Ant Design origiFileObj
 * @returns Promise
 */
export function normFileAsDataUrl(img: Blob): Promise<string | undefined> {
  return new Promise((resolve, reject) => {
    if (!img) {
      return resolve(undefined);
    }

    const reader = new FileReader();
    reader.onerror = reject;
    reader.onloadend = () => resolve(reader.result as string);

    reader.readAsDataURL(img);
  });
}

export async function ConvertFileToBase64String(uid: string, gid: string) {
  const file = getFilebyUid(uid, gid);
  if (file) {
    const base64String = await normFileAsDataUrl(file);
    return base64String;
  }
  return null;
}
